<template>
  <SendByEmailDialog :is-open="isDialogOpened"
                     :cancelDisabled="sendArchivesPending"
                     :okLoading="sendArchivesPending"
                     :title="$t('archives.dialogs.ArchivesListSendByEmailDialog.title')"
                     @cancel="closeDialog"
                     @send="sendArchive"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'

import SendByEmailDialog from '@/common/dialogs/SendByEmailDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { ArchivesActionTypes } from '@/store/modules/archives/action_types'

export default {
  name: 'ArchivesListSendByEmailDialog',
  components: { SendByEmailDialog },
  mixins: [dialogMixin],
  props: {
    archiveId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('archives', ['sendArchivesPending']),
  },
  methods: {
    ...mapActions('archives', [ArchivesActionTypes.SEND_ARCHIVES]),
    async sendArchive(emailAddresses) {
      if (emailAddresses.length === 0) {
        return
      }

      try {
        await this.SEND_ARCHIVES({
          params: {
            archivesFilesIds: [this.archiveId],
            emails: emailAddresses,
          },
        })

        toast.success(this.$t('archives.dialogs.ArchivesListSendByEmailDialog.sendSuccess'))
        this.closeDialog()
      } catch (error) {
        console.error(error)
        const errorMessage = error.response?.data?.errorCode === 'ERR_INVALID_RIGHTS' ? 'sendInvalidRightsError' : 'sendError'
        toast.error(this.$t(`archives.dialogs.ArchivesListSendByEmailDialog.${errorMessage}`))
      }
    },
  },
}
</script>
